import { all, call, put, select, takeEvery, delay } from "redux-saga/effects";

import {
  getEventsFailed,
  getEventsStart,
  getEventsSuccess,
} from "../redux/getEvents";

import { getEventsApi } from "core/http/service/internalEvents";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";

export const statusMapping = {
  "in-process": "DANG_DIEN_RA",
  "in-coming": "CHO_DIEN_RA",
  over: "DA_KET_THUC",
};

function* getEventsWork(action: ReturnType<typeof getEventsStart>) {
  const { status } = action.payload;
  const { offset, limit } = yield select(controlInfinitiveScrollSelector(null));

  try {
    const res = yield call(getEventsApi, {
      offset,
      limit,
      status: statusMapping[status] || "DANG_DIEN_RA",
    });

    yield delay(300);

    yield put({
      type: getEventsSuccess.type,
      payload: {
        data: res.data,
      },
    });
  } catch (error: any) {
    yield put({
      type: getEventsFailed.type,
    });
  }
}

function* watchGetEvents() {
  yield takeEvery(getEventsStart.type, getEventsWork);
}

export default function* getEventsSaga() {
  yield all([watchGetEvents()]);
}
